@if (isMultiCity$ | async) {
  <fin-multi-city-view [flightSearch$]="fetchParams$"></fin-multi-city-view>
} @else if (useFpp$ | async) {
  <fin-air-bounds-booking-ticket-selection-view
    (selectionPhaseChange)="selectionPhaseChanged($event)"
    [goToOutboundPhase$]="goToOutboundPhase$"
    (refetchOffers)="fetchOffers()"
  >
  </fin-air-bounds-booking-ticket-selection-view>
} @else {
  <fin-booking-ticket-selection-view
    (selectionPhaseChange)="selectionPhaseChanged($event)"
    [goToOutboundPhase$]="goToOutboundPhase$"
    (refetchOffers)="fetchOffers()"
  ></fin-booking-ticket-selection-view>
}
